import { render, staticRenderFns } from "./user-modal-add-color.vue?vue&type=template&id=3f82bf88"
import script from "./user-modal-add-color.vue?vue&type=script&lang=js"
export * from "./user-modal-add-color.vue?vue&type=script&lang=js"
import style0 from "./user-modal-add-color.vue?vue&type=style&index=0&id=3f82bf88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports